/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_User_CreatedInputs */

const en_team_manager_user_created = /** @type {(inputs: Team_Manager_User_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New user created`)
};

const fr_team_manager_user_created = /** @type {(inputs: Team_Manager_User_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvel utilisateur créé`)
};

const de_team_manager_user_created = /** @type {(inputs: Team_Manager_User_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Benutzer erstellt`)
};

const it_team_manager_user_created = /** @type {(inputs: Team_Manager_User_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo utente creato`)
};

const ru_team_manager_user_created = /** @type {(inputs: Team_Manager_User_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создан новый пользователь.`)
};

const es_team_manager_user_created = /** @type {(inputs: Team_Manager_User_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo usuario creado`)
};

const zh_cn2_team_manager_user_created = /** @type {(inputs: Team_Manager_User_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新用户`)
};

const ja_team_manager_user_created = /** @type {(inputs: Team_Manager_User_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいユーザーが作成されました`)
};

const hi_team_manager_user_created = /** @type {(inputs: Team_Manager_User_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया उपयोगकर्ता बनाया गया`)
};

const pt_pt2_team_manager_user_created = /** @type {(inputs: Team_Manager_User_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo usuário criado`)
};

/**
* | output |
* | --- |
* | "New user created" |
*
* @param {Team_Manager_User_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_created = /** @type {((inputs?: Team_Manager_User_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_user_created(inputs)
	if (locale === "de") return de_team_manager_user_created(inputs)
	if (locale === "it") return it_team_manager_user_created(inputs)
	if (locale === "ru") return ru_team_manager_user_created(inputs)
	if (locale === "es") return es_team_manager_user_created(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_user_created(inputs)
	if (locale === "ja") return ja_team_manager_user_created(inputs)
	if (locale === "hi") return hi_team_manager_user_created(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_user_created(inputs)
	return en_team_manager_user_created(inputs)
});